import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import client from "./../../../../../vendor/rshop/frontend/assets/js/common/client";
import { tippyAlert } from "../../../common/tippy";


// vue config
const devMode = process.env.NODE_ENV === 'development' || window.Eshop.options.debug

Vue.config.devtools = devMode
Vue.config.debug = devMode
Vue.config.silent = !devMode
Vue.config.productionTip = devMode
Vue.config.ignoredElements = ['r-span', 'r-slider', 'r-tabs', 'r-toggle', 'r-shorten', 'r-more-items', 'r-favorite-trigger']

Vue.use(VueI18n)
Vue.use(Vuex);

const i18n = new VueI18n({
    locale: document.querySelector('html').getAttribute('lang'),
    fallbackLocale: 'sk',
    messages: {
        sk: require('../../../locale/sk.json'),
    }
});

const endpoints = {
    currentReservation: '/aktualna-rezervacia',
    addProductToReservation: '/pridat-produkt-rezervacia',
    removeProductFromReservation: '/odstranit-produkt-rezervacia',
    submitReservation: '/odoslat-rezervaciu',
    addVoucher: '/pridat-voucher',
    removeVoucher: '/odstranit-voucher',
    changeQuantity: '/zmenit-mnozstvo-rezervacia',
    removeReservation: '/odstranit-rezervaciu',
    changeBranch: '/zmenit-pobocku-rezervacie',
}

const BranchReservationStore = new Vuex.Store({
    state: {
        hasPendingRequest: false,
        reservationData: null,
        successReservationData: null
    },
    getters: {
        // TODO: probably some better way, than just checking for length of products
        isEmpty(state) {
            const hasProducts = state.reservationData?.products?.length > 0
            const modalEl = document.querySelector('.js-product-reservation-modal')

            if (modalEl) {
                modalEl.classList.toggle('is-empty', !hasProducts)
            }

            return !hasProducts
        },
        isSuccess(state) {
            const isReservationSuccess = state.successReservationData !== null
            const modalEl = document.querySelector('.js-product-reservation-modal')

            if (modalEl) {
                modalEl.classList.toggle('is-success', isReservationSuccess)
            }

            return isReservationSuccess
        },
        hasVouchers(state) {
            return state.reservationData?.vouchers?.length > 0
        },
        reservationCutoffDate(state) {
            return state.reservationData?.branch?.custom_reservation_cutoff_with_year
        },
        customReservationSince(state) {
            return state.reservationData?.branch?.custom_reservation_since
        }
    },
    actions: {
        async doRequest({ commit, dispatch, state }, requestConfig = {}) {
            if (state.hasPendingRequest) {
                return
            }

            commit('setHasPendingRequest', true)

            let response = {}
            try {
                response = await client.request(requestConfig)
            } catch (error) {
                if (error?.response?.data?.message) {
                    console.error('SERVER_ERROR', error.response.data.message)
                } else {
                    console.error(error)
                }

                dispatch('showAlert', {
                    message: i18n.t('BranchReservation.serverErrorMessage'),
                    tippyOptions: {
                        theme: 'error',
                    },
                    delay: 10000,
                })
            }

            if (response?.data?.reservationData) {
                commit('setReservationData', response.data.reservationData)
            }

            commit('setHasPendingRequest', false)

            return response
        },
        async addProductToReservation({ dispatch }, { productId, branchId = null, distance = null }) {
            const data = { product_id: productId }
            if (branchId) {
                data.branch_id = branchId
            }
            if (distance) {
                data.distance = distance
            }
            return await dispatch('doRequest', {
                method: 'POST',
                url: endpoints.addProductToReservation,
                data,
            })
        },
        async removeProductFromReservation({ dispatch }, { productId }) {
            return await dispatch('doRequest', {
                method: 'POST',
                url: endpoints.removeProductFromReservation,
                data: {
                    product_id: productId,
                },
            })
        },
        async changeProductQuantity({ dispatch }, { productId, quantity }) {
            return await dispatch('doRequest', {
                method: 'POST',
                url: endpoints.changeQuantity,
                data: {
                    product_id: productId,
                    quantity: quantity,
                },
            })
        },
        async retrieveCurrentReservation({ getters, dispatch }) {
            if (getters.isSuccess) return

            return await dispatch('doRequest', {
                method: 'GET',
                url: endpoints.currentReservation,
            })
        },
        async selectBranch({ dispatch }, { branchId, force = false, distance = null }) {
            const data = {
                branch_id: branchId,
                force: force,
            }
            if (distance) {
                data.distance = distance
            }
            return await dispatch('doRequest', {
                method: 'POST',
                url: endpoints.changeBranch,
                data,
            })
        },
        async addVoucher({ dispatch }, { voucherCode }) {
            return await dispatch('doRequest', {
                method: 'POST',
                url: endpoints.addVoucher,
                data: {
                    voucher_code: voucherCode,
                },
            })
        },
        async removeVoucher({ dispatch }, voucherCartId) {
            return await dispatch('doRequest', {
                method: 'POST',
                url: endpoints.removeVoucher,
                data: {
                    voucher_id: voucherCartId,
                },
            })
        },
        async submitReservation({ dispatch }, { email, phone }) {
            return await dispatch('doRequest', {
                method: 'POST',
                url: endpoints.submitReservation,
                data: {
                    email: email,
                    phone: phone,
                },
            })
        },
        async cancelReservation({ dispatch }) {
            return await dispatch('doRequest', {
                url: endpoints.removeReservation,
            })
        },
        hideModal(){
            $('#product-reservation').modal('hide')
        },
        setSuccessReservation({ commit }, successReservationData) {
            return commit('setSuccessReservation', successReservationData)
        },
        resetReservationData({commit}){
            return commit('resetReservationData');
        },
        hideReservationModalAndShowMessage({ dispatch }) {
            $('#product-reservation').modal('hide')
        },
        showAlert({}, { targetEl, message, tippyOptions = {}, delay }) {
            if (!targetEl) {
                targetEl = document.querySelector('.js-reservation-tippy-target')
            }

            tippyAlert(
                targetEl,
                message,
                {
                    ...{
                        theme: 'success',
                        zIndex: 9999
                    },
                    ...tippyOptions
                },
                delay
            )
        },
    },
    mutations: {
        setReservationData(state, reservationData) {
            // TODO: temp fix, from BE it's coming as an object, therefore conversion to array
            reservationData.products = Object.values(reservationData.products)
            reservationData.vouchers = Object.values(reservationData.vouchers)
            reservationData.availableBranches = Object.values(reservationData.availableBranches)

            state.reservationData = reservationData
            state.successReservationData = null
            setModalTitle(null)

            updateCountsInButtons(reservationData)
        },
        setHasPendingRequest(state, hasPendingRequest) {
            state.hasPendingRequest = hasPendingRequest
        },
        setSuccessReservation(state, successReservationData) {
            state.successReservationData = successReservationData

            if (window.matchMedia('(max-width: 767px)').matches) {
                setModalTitle(i18n.t('BranchReservation.Success.modalTitle'))
            }

            localStorage.removeItem('reservation-email')
            localStorage.removeItem('reservation-phone')
        },
            resetReservationData(state){
                state.successReservationData = null
                setModalTitle(null)
                state.reservationData= null
               updateCountsInButtons(null)
            }
    }
})

function setModalTitle(text) {
    const el = document.querySelector('.js-product-reservation-modal .c-modal__name')

    if (!el) return

    if (!el.dataset.title) {
        el.dataset.title = el.textContent.trim()
    }

    el.textContent = text || el.dataset.title
}

function updateCountsInButtons(reservationData) {
    for (const reservationCountEl of document.querySelectorAll('.js-reservation-count')) {
        const productsCount = reservationData?.products?.length || 0

        reservationCountEl.innerText = productsCount
        reservationCountEl.dataset.count = productsCount
    }
}

export default BranchReservationStore
